import { render, staticRenderFns } from "./MisRequisiciones.vue?vue&type=template&id=fba7197a&"
import script from "./MisRequisiciones.vue?vue&type=script&lang=js&"
export * from "./MisRequisiciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports